import { render, staticRenderFns } from "./ManagePotInternal.vue?vue&type=template&id=cde0a4b0&"
import script from "./ManagePotInternal.vue?vue&type=script&lang=js&"
export * from "./ManagePotInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports